"use strict";
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var _1 = require('./');
var MIN_DATE_VALIDATOR = {
    provide: forms_1.NG_VALIDATORS,
    useExisting: core_1.forwardRef(function () { return MinDateValidator; }),
    multi: true
};
var MinDateValidator = (function () {
    function MinDateValidator() {
    }
    MinDateValidator.prototype.ngOnInit = function () {
        this.validator = _1.minDate(this.minDate);
    };
    MinDateValidator.prototype.ngOnChanges = function (changes) {
        for (var key in changes) {
            if (key === 'minDate') {
                this.validator = _1.minDate(changes[key].currentValue);
                if (this.onChange)
                    this.onChange();
            }
        }
    };
    MinDateValidator.prototype.validate = function (c) {
        return this.validator(c);
    };
    MinDateValidator.prototype.registerOnValidatorChange = function (fn) {
        this.onChange = fn;
    };
    MinDateValidator.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[minDate][formControlName],[minDate][formControl],[minDate][ngModel]',
                    providers: [MIN_DATE_VALIDATOR]
                },] },
    ];
    /** @nocollapse */
    MinDateValidator.ctorParameters = [];
    MinDateValidator.propDecorators = {
        'minDate': [{ type: core_1.Input },],
    };
    return MinDateValidator;
}());
exports.MinDateValidator = MinDateValidator;
//# sourceMappingURL=directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-validation/dist/min-date/directive.js
// module id = 1164
// module chunks = 10